import { createFileRoute } from "@tanstack/react-router";
import Compare from "@/pages/Compare";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/compare/")({
  head: () => routeHead("/de/compare/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Compare />
  );
}
